import apiClient from 'api/common/common'
import { PortalRedirectResponse } from 'api/common/responses'
import { Status } from 'api/common/statuses'
import { AxiosResponse } from 'axios'

/**
 * ポータルリダイレクトURL取得API
 * @param token ポータルトークン（任意）
 */
export const portalRedirectUrlAPI = async (
  token: string | undefined,
  uid?: string,
): Promise<{ status: Status; data: PortalRedirectResponse }> => {
  const params: Record<string, string> = {}
  if (token) {
    params.token = token
  }
  if (uid) {
    params.uid = uid
  }

  const path = token && !uid ? '/portal-api/token' : '/portal-api/redirect-url'

  const response: AxiosResponse<PortalRedirectResponse> = await apiClient.get(path, {
    params: Object.keys(params).length > 0 ? params : undefined,
  })
  const status = (response?.headers['x-aqc-status'] as Status) ?? Status.InternalError
  return { status, data: response.data }
}
